module.exports = __webpack_public_path__ + "static/background-da33efe620f5d9d984c4438d9eca74af.mp4";